<template>
  <div class="page-works">


    <div class="left-right-content clearfix">
      <div class="c-left">

        <div >
         <div class="paeparation" style="margin: 0"  >
           <!-- <ul class="tabs-select clearfix">
             <li class="item active">中华上下五千年</li>
             <li class="item">中国成语故事</li>
             <li class="item">中国寓言故事</li>
             <li class="item">其他故事</li>
           </ul>
          <div class="search">
            <el-input class="ipt" size="large" placeholder="请输入故事名称"></el-input>
            <div class="btn">
              <i class="el-icon-search">搜索</i>
            </div>
          </div> -->
          <div class="types-list">
            <div class="type-item clearfix" >
              <div class="tit">主题：</div>
              <ul class="cases clearfix">
                <li :class="childTypes[0] && productionParam.productionType == childTypes[0].parentId?'active':''" v-on:click="selectProTypeChild(childTypes[0].parentId,1)">全部</li>
                <li :class="productionParam.productionType == item.id?'active':''" v-on:click="selectProTypeChild(item.id,2)" v-for="(item,index) in childTypes" :key="index">{{item.tag}}</li>
              </ul>
            </div>
            <!--<div class="type-item clearfix">
              <div class="tit">朝代：</div>
              <ul class="cases clearfix">
&lt;!&ndash;                <li :class="productionParam.productionType == threeTypes[0].parentId?'active':''" v-on:click="selectProTypeThreeChild(item.p)">全部</li>&ndash;&gt;
                <li :class="productionParam.productionType == item.id ?'active':''" v-for="(item,index) in threeTypes" :key="index" v-on:click="selectProTypeThreeChild(item.id)">{{item.tag}}</li>
              </ul>
            </div>-->

            <div class="type-item clearfix">
              <div class="tit">朝代：</div>
              <ul class="cases clearfix">
                <li :class="productionParam.groupType == ''?'active':''" v-on:click="selectProTypeHis(0)">全部</li>
                <li :class="productionParam.groupType == item.id ?'active':''" v-for="(item,index) in historyList" :key="index" v-on:click="selectProTypeHis(item.id)">{{item.tag}}</li>
              </ul>
            </div>
            <!-- <div class="type-item clearfix w-p">
              <div class="tit">排序：</div>
              <ul class="cases clearfix">
                <li class="active">发布时间<i class="el-icon-sort-up"></i></li>
                <li>故事热度<i class="el-icon-sort-down"></i></li>
                <li>
                  <el-checkbox v-model="aboutJuben">关联剧本</el-checkbox>
                </li>
                <p class="words-pics">
                  文字/图文列表
                </p>
              </ul>
            </div> -->

          </div>
        </div>


          <div v-if="isGS">
            <div class="story-item" v-for="(item,index) in productionData" :key="index" >
            <div class="lft-tits">
              <div class="tit-type clearfix">
                <router-link target="_blank" :to="{ path: '/workstory', query: { id: item.id ,plate:item.belongSection} }" class="s-tit">{{item.productionName}}</router-link>
                <span class="s-type" :title="item.tagStr">{{item.tagStr}}</span>
              </div>
              <div class="guanlian" v-if="item.proRelateList.length >0">
                关联剧本：
                <span class="gl" v-for="(item_relate,index_relate) in item.proRelateList" :key="index_relate">
                  <router-link v-if="item_relate.production" target="_blank" :to="{ path: '/workstory', query: { id: item_relate.production.id,plate:item_relate.production.belongSection } }">
                    {{item_relate.production.productionName}}
                  </router-link>
                </span>
              </div>
              <div class="guanlian" v-else>
                关联剧本：
                <router-link target="_blank" :to="{ path: '/workstory', query: { id: item.id ,plate:item.belongSection} }" >
                <span class="gb-btn">我来改编剧本</span>
                </router-link>
              </div>
            </div>

            <div class="rig-info">
              <div class="usr">
                <router-link :to="{ path: '/home', query: { userId: item.creatorId } }" target="_blank" class="usr-avatar" :style="{'background-image': 'url(' + item.imgUrl+ ')'}"></router-link>
                <router-link :to="{ path: '/home', query: { userId: item.creatorId } }" target="_blank" class="usr-name">{{ item.creatorName }}</router-link>
              </div>
              <div class="date">{{item.createTime | formatTime}}</div>
            </div>
          </div>

            <!--<div class="story-item">
              <div class="lft-tits">
                <div class="tit-type clearfix">
                  <router-link to="/workstory?id=1161" class="s-tit">故事名称故事名称故事名称故事名称故事名称故事名称</router-link>
                  <span class="s-type">秦汉</span>
                </div>
                <div class="guanlian">
                  关联剧本：
                  <span class="gb-btn">我来改编剧本</span>
                </div>
              </div>
              <div class="rig-info">
                <div class="usr">
                  <router-link to="" class="usr-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></router-link>
                  <router-link to="" class="usr-name">作者名称</router-link>
                </div>
                <div class="date">刚刚</div>
              </div>
            </div>-->


        </div>

          <div v-if="isJB">
            <div class="story-item" v-for="(item,index) in productionData" :key="index" >
              <div class="lft-tits">
                <div class="tit-type clearfix">
                  <router-link  target="_blank" :to="{ path: '/workstory', query: { id: item.id,plate:item.belongSection } }" class="s-tit">{{item.productionName}}</router-link>
                  <span class="s-type" :title="item.tagStr">{{item.tagStr}}</span>
                </div>
                <div class="guanlian" v-if="item.proRelateList.length >0">
                  关联故事：
                  <span class="gl" v-for="(item_relate,index_relate) in item.proRelateList" :key="index_relate">
                     <router-link v-if="item_relate.production" target="_blank" :to="{ path: '/workstory', query: { id: item_relate.production.id ,plate:item_relate.production.belongSection} }" class="s-tit">{{item_relate.production.productionName}}</router-link>
                  </span>
                </div>
                <div class="guanlian" v-else>
                  关联故事：
                  <span class="no">暂无</span>
                </div>
              </div>
              <div class="rig-info">
                <div class="usr">
                  <router-link :to="{ path: '/home', query: { userId: item.creatorId } }" target="_blank" class="usr-avatar" :style="{'background-image': 'url(' + item.imgUrl+ ')'}"></router-link>
                  <router-link :to="{ path: '/home', query: { userId: item.creatorId } }" target="_blank" class="usr-name">{{ item.creatorName }}</router-link>
                </div>
                <div class="date">{{item.createTime | formatTime}}</div>
              </div>
            </div>

            <!--<div class="story-item">
              <div class="lft-tits">
                <div class="tit-type clearfix">
                  <router-link to="/workstory?id=1161" class="s-tit">剧本剧本剧本剧本剧本剧本剧本剧本</router-link>
                  <span class="s-type">秦汉</span>
                </div>
                <div class="guanlian">
                  关联故事：
                  <span class="no">暂无</span>
                </div>
              </div>
              <div class="rig-info">
                <div class="usr">
                  <router-link to="" class="usr-avatar" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}"></router-link>
                  <router-link to="" class="usr-name">作者名称</router-link>
                </div>
                <div class="date">刚刚</div>
              </div>
            </div>-->
          </div>

          <!-- <div class="projn-list">
            <div class="projn-item">
              <router-link
                to=""
                class="left-img"
                :style="{backgroundImage: 'url(' + require('@/assets/images/gs.jpg') + ')'}"
              >
              </router-link>
              <router-link to="" class="mobile-mask"></router-link>
              <div class="itemn-info">
                <div class="item-tit">
                  <div class="tit-type clearfix">
                    <router-link to="" class="tit-nam">大型动画剧集</router-link>
                    <span class="type bjz">神话传说</span>
                  </div>
                </div>
                <div class="pro-type">发布时间：2020-12-08</div>
                <div class="btn-has-user">
                  <div class="pro-end-date">关联剧本：【神话故事】| 神农尝百草</div>
                  <router-link to="" class="user-info">
                    <span class="avat" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}" alt=""></span>
                    张三
                  </router-link>
                </div>
              </div>
            </div>
            <div class="projn-item">
              <router-link
                to=""
                class="left-img"
                :style="{backgroundImage: 'url(' + require('@/assets/images/gs.jpg') + ')'}"
              >
              </router-link>
              <router-link to="" class="mobile-mask"></router-link>
              <div class="itemn-info">
                <div class="item-tit">
                  <div class="tit-type clearfix">
                    <router-link to="" class="tit-nam">【帝王起居注】西周| 一场禁言引发的暴动-闭嘴是多么严峻暴动-闭嘴是多么严峻的酷刑</router-link>
                    <span class="type bjz">神话传说</span>
                  </div>
                </div>
                <div class="pro-type">发布时间：2020-12-08</div>
                <div class="btn-has-user">
                  <div class="pro-end-date">关联剧本：【神话故事】| 神农尝百草</div>
                  <router-link to="" class="user-info">
                    <span class="avat" :style="{'background-image': 'url(' + require('@/assets/images/user_avatar.jpg') + ')'}" alt=""></span>
                    张三
                  </router-link>
                </div>
              </div>
            </div>
          </div> -->
      </div>

        <!--<div v-else>
          <div
          class="pro-work-item clearfix"
          v-for="(item, index) in productionData"
          :key="index"
        >
          <div class="user-avatar">
            <router-link
              :to="{ path: '/home', query: { userId: item.creatorId } }"
              class="avatar-f"
            >
              <img :src="item.imgUrl" alt="" />
            </router-link>
            <div class="tip-title" v-if="item.isChoiceness">精选</div>
          </div>
          <div class="item-infoes">
            &lt;!&ndash; username 和 称号 &ndash;&gt;
            <div class="user-name-title clearfix">
              <router-link
                :to="{ path: '/home', query: { userId: item.creatorId } }"
                class="name"
                >{{ item.creatorName }}</router-link
              >
              <div
                class="new-tchh clearfix"
                v-if="item.userRankName != '' && item.userRankName != null"
              >
                <i
                  class="icon zs"
                  v-if="item.userRankName.split(',')[1] == '资深作者'"
                ></i>
                <i
                  class="icon yx"
                  v-if="item.userRankName.split(',')[1] == '优秀作者'"
                ></i>
                <i
                  class="icon hy"
                  v-if="item.userRankName.split(',')[1] == '活跃作者'"
                ></i>
                <span class="zuoz">{{ item.userRankName.split(",")[1] }}</span>
                <span class="shu">|</span>
                <span class="liny">{{ item.userRankName.split(",")[0] }}</span>
              </div>
            </div>
            &lt;!&ndash; 文字 &ndash;&gt;




            <router-link
              class="user-words"
              :class="{archiveE: item.productionForm == 3}"
              :to="{ path: '/worksdetail', query: { id: item.id } }"
              target="_blank"
            >
              <div v-html="item.productionInrto" ></div>

            </router-link>


            &lt;!&ndash; 文章类 &ndash;&gt;
            <div v-if="item.productionForm == 3" >
              &lt;!&ndash;<div class="zhuti-tit">{{item.productionName}}</div>
              <div class="no-success-add common-list-video">
                <img class="img-fm" :src="item.productionCover" alt="" />
              </div>&ndash;&gt;
            </div>
            &lt;!&ndash; 九宫格图片 &ndash;&gt;
            &lt;!&ndash; <div class="images-list clearfix mobile-show" v-if="item.productionForm==1">
              <div v-for="(item_bak, index_bak) in item.picList"  :key="index_bak"  >
                <router-link :to="{path:'/worksdetail',query:{id:item.id}}"  target="_blank"  class="img-grid" v-if="index_bak < 9"  :style="{'background-image': 'url(' + item_bak.url + ')'}"></router-link>
              </div>

            </div> &ndash;&gt;
            <vue-viewer
              class="images-list clearfix"
              v-else-if="item.productionForm == 1"
              :thumb="item.picUrlList"
              :full="item.picUrlList"
            >
            </vue-viewer>

            <div v-else-if="item.videoSource == 1">
              <div class="demand-play" v-if="item.productionVideo != ''">
                &lt;!&ndash;<cc-video :ccsrc="item.productionVideo" :ccPic="item.productionCover" v-if="item.videos.status == 1 "></cc-video>&ndash;&gt;
                &lt;!&ndash;<cc-video class="common-list-video" v-if="item.videos.status == 1 " :ccPic="item.productionCover" :ccsrc="item.productionVideo"></cc-video>&ndash;&gt;

                <div
                  v-html="item.videoIframeHtml"
                  class="common-list-video"
                  v-if="item.videos.status == 1"
                ></div>

                <div
                  class="no-success-add common-list-video"
                  v-if="item.videos.status == 0 || item.videos.status == 2"
                >
                  <img class="img-fm" :src="item.productionCover" alt="" />
                  <i
                    class="no-play-icon"
                    @click="notStatus(item.videos.status)"
                  ></i>
                </div>
              </div>
            </div>

            <div
              v-else
              v-html="item.videoCode"
              class="iframe-h common-list-video"
            ></div>

            &lt;!&ndash;<div     class="o-video" v-else>&ndash;&gt;
            &lt;!&ndash;<router-link :to="{path:'/worksdetail',query:{id:item.id}}"  target="_blank">&ndash;&gt;
            &lt;!&ndash;<img :src="item.productionCover" alt="">&ndash;&gt;
            &lt;!&ndash;<div class="mask">&ndash;&gt;
            &lt;!&ndash;<i class="el-icon-video-play"></i>&ndash;&gt;
            &lt;!&ndash;</div>&ndash;&gt;
            &lt;!&ndash;</router-link>&ndash;&gt;
            &lt;!&ndash;</div>&ndash;&gt;

            &lt;!&ndash; 类型 关注 标签 &ndash;&gt;
            <div class="type-tags">
              <span class="type">{{ item.tagStr }}</span>
              <span
                class="follow-btn"
                v-if="!isAtt && isStatus"
                v-on:click="addUserTag()"
                >关 注</span
              >
              <span
                v-if="item.activityId > 0"
                class="tag-item"
                @click="selActivity(item.productionType, item.tagStr)"
                style="cursor: pointer"
              >
                活动
              </span>
              <span
                class="tag-item"
                v-for="(item_bak, index_bak) in item.tags"
                :key="index_bak"
                @click="selectTab2(item_bak.tag)"
                :class="{'active': item_bak.tag ==productionParam.productionTags?true:false }"
                style="cursor: pointer"
                >
                <font style="color: #ee4b58" v-if="item_bak.tag ==productionParam.productionTags">{{ item_bak.tag }}</font>
                <font v-else>{{ item_bak.tag }}</font>
              </span>
            </div>
            <talkPart
              :objType="1"
              :objId="item.id"
              v-if="isReload"
              :key="item.id"
              :loadShow="false"
            ></talkPart>
          </div>
        </div>
        </div>
-->


        <div class="pagintion-f">
          <el-pagination
            background
            @current-change="changePage"
            layout="prev, pager, next,jumper"
            :current-page.sync="productionParam.pageIndex"
            :page-size="productionParam.pageSize"
            :total="total"
            :hide-on-single-page="true"
          >
          </el-pagination>
        </div>


      </div>


      <div class="c-right">
        <!--第二版本 精选-->
        <div class="one-item" v-if="cParam.total > 0">
          <div class="one-title">
            精选{{ hotType }}
            <i
              class="el-icon-refresh-right shuaxin"
              @click="getChoicenessList()"
            ></i>
          </div>
          <div class="works-list">
            <router-link
              :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
              class="item"
              :title="item.productionName"
              v-for="(item, index) in cList"
              :key="index"
              target="_blank"
            >
              <div class="work-img-f">
                <img :src="item.productionCover" alt="" />
              </div>
              <div class="work-title">{{ item.productionName }}</div>
            </router-link>
          </div>
        </div>













        <!--第二版本 推荐     && rParam.productionType !=2  -->
        <div class="one-item" v-if="rParam.total > 0">
          <div class="one-title">
            推荐{{ hotType }}
            <i
              class="el-icon-refresh-right shuaxin"
              @click="getRecommendList()"
            ></i>
          </div>
          <div class="works-list">
            <router-link
              :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
              class="item"
              :title="item.productionName"
              v-for="(item, index) in rList"
              :key="index"
              target="_blank"
            >
              <div class="work-img-f">
                <img :src="item.productionCover" alt="" />
              </div>
              <div class="work-title">{{ item.productionName }}</div>
            </router-link>
          </div>
        </div>

        <!--        &lt;!&ndash; 第一版本 热门/推荐&ndash;&gt;-->
        <!--        <div class="one-item">-->
        <!--          <div class="one-title">-->
        <!--            推荐{{hotType}}-->
        <!--            <i class="el-icon-refresh-right shuaxin" @click="getHotByType()"></i>-->
        <!--          </div>-->
        <!--          <div class="works-list">-->

        <!--            <router-link :to="{path:'/worksdetail',query:{id:item.id}}"  class="item" v-for="(item,index) in hotOne" :key="index">-->
        <!--              <div class="work-img-f">-->
        <!--                <img :src="item.productionCover" alt="">-->
        <!--              </div>-->
        <!--              <div class="work-title">{{item.productionName}}</div>-->
        <!--            </router-link>-->
        <!--          </div>-->
        <!--        </div>-->

        <div class="one-item" v-if="hParam.total > 0">
          <!-- 第二版本 热门动画 -->
          <div class="one-title">
            推荐动画
            <i class="el-icon-refresh-right shuaxin" @click="getHotList()"></i>
          </div>
          <div class="works-list">
            <router-link
              :to="{ path: '/worksdetail', query: { id: item.id,plate:item.belongSection } }"
              class="item"
              :title="item.productionName"
              v-for="(item, index) in hList"
              :key="index"
            >
              <div class="work-img-f">
                <img :src="item.productionCover" alt="" />
                <div class="mask">
                  <i class="el-icon-video-play play-icon"></i>
                </div>
              </div>
              <div class="work-title">{{ item.productionName }}</div>
            </router-link>
          </div>

          <!--          &lt;!&ndash; 第一版本 热门动画 &ndash;&gt;-->
          <!--          <div class="one-title">-->
          <!--            热门动画-->
          <!--            <i class="el-icon-refresh-right shuaxin" @click="getHotMove()"></i>-->
          <!--          </div>-->
          <!--          <div class="works-list">-->

          <!--            <router-link :to="{path:'/worksdetail',query:{id:item.id}}"  class="item" v-for="(item,index) in hotTwo" :key="index">-->
          <!--              <div class="work-img-f">-->
          <!--                <img :src="item.productionCover" alt="">-->
          <!--                <div class="mask"><i class="el-icon-video-play play-icon"></i></div>-->
          <!--              </div>-->
          <!--              <div class="work-title">{{item.productionName}}</div>-->
          <!--            </router-link>-->
          <!--          </div>-->
        </div>
      </div>
    </div>
    <!-- 分享弹窗 -->
    <el-dialog
      title="分享到"
      class="common-dialog"
      :visible.sync="dialogVisibleShare"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      append-to-body
    >
      <ul class="dialog-share-list clearfix">
        <li>
          <div class="img-f" @click="shareMy">
            <img :src="require('@/assets/images/share_01.png')" alt="" />
          </div>
          <p>我的动态</p>
        </li>
        <li @click="shareWechat">
          <div class="img-f">
            <img :src="require('@/assets/images/share_02.png')" alt="" />
          </div>
          <p>微信</p>
        </li>
        <li @click="shareWeibo">
          <div class="img-f">
            <img :src="require('@/assets/images/share_03.png')" alt="" />
          </div>
          <p>微博</p>
        </li>
        <li @click="shareQQzone">
          <div class="img-f">
            <img :src="require('@/assets/images/share_04.png')" alt="" />
          </div>
          <p>QQ空间</p>
        </li>
        <li>
          <div class="img-f">
            <img :src="require('@/assets/images/share_05.png')" alt="" />
          </div>
          <p>生成海报</p>
        </li>
        <li @click="copyLink">
          <div class="img-f">
            <img :src="require('@/assets/images/share_06.png')" alt="" />
          </div>
          <p>复制链接</p>
        </li>
        <!-- <li>
          <div class="img-f">
            <img :src="require('@/assets/images/share_01.png')" alt="">
          </div>
          <p>收藏</p>
        </li> -->
      </ul>
      <el-dialog
        title="分享到微信"
        class="common-dialog"
        :visible.sync="dialogVisibleShareWechat"
        :close-on-click-modal="false"
        append-to-body
      >
        <div ref="qrcode" id="qrcode" class="dialog-share-wechat"></div>
      </el-dialog>
    </el-dialog>
    <!-- 举报 -->
    <el-dialog
      title="举报理由"
      class="common-dialog"
      :visible.sync="dialogVisibleJubao"
      :close-on-click-modal="false"
    >
      <div class="dialog-jubao-cont">
        <el-checkbox-group v-model="jubaolist">
          <el-checkbox label="侵犯版权"></el-checkbox>
          <el-checkbox label="内容低俗"></el-checkbox>
          <el-checkbox label="恶意灌水"></el-checkbox>
          <el-checkbox label="其他"></el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleJubao = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
//import QRCode from 'qrcodejs2'
import productionApi from '@/api/production'
import axios from 'axios';
import vue from 'vue';
import tagApi from '@/api/tags'
vue.prototype.$axios = axios;
import updateTdk from "@/utils/tdk";
import talkPart from '@@/pub/talkpart/talkpart'
import apiService from '@/api/index'
import vueViewer from '@@/pub/viewer/viewer'
import {mapState} from "vuex";

export default {
  components: {
    //vueViewer,talkPart//,Pagination,CcVideo
  },
  data () {
    return {
      headTitle: "title---rrdh",
      headKeywords: "keywords---rrdh",
      headDesc: "description---rrdh",
      isMounted: false, //for control not ssr render

      isLogin:false,
      keywords:"",
      isAtt: false, //是否关注类型
      isStatus:true, //传入类型状态是否可用
      parameTagId:"",
      parameTagName:"",
      parameTagStr:"",
      isReload:true,
      contTabIndex: 0,
      childTabIndex:0,
      total:0,
      contTabs: ['模型', '动画', '剪辑', '动图', '分镜', '插画'],
      childTypes:[],
      threeTypes:[],

      historyParam:{
        status:1,
        type:3
      },
      historyList:[],
      historyVal:'',



      textCon: '',
      activitiesAnd: false,
      dialogVisibleShare: false,
      dialogVisibleShareWechat: false,
      dialogVisibleJubao: false,
      jubaolist: [],
      productionData:[],//列表数据
      tagParam:{
        parentId:-1,
      },
      tagParam2:{},
      hotType:'',
      productionParam:{
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 10,
        pageSizes:[10,20,30],
        groupType:'',
        productionType:1,//作品类型
        productionTags:'',//作品 标签
      },
      hotParam:{
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 2,
        productionType:'',//作品类型  --从字典表提取；
        productionForm:1,//作品形式  --1为图片；2为视频；
        orderType:'hot',
      },
      hotOne:[],
      hotTwo:[],
      // aboutJuben: true,


      ///////页面 右侧
      //choiceness 精选
      cParam:{
        total:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 5,
        time: new Date().getMilliseconds(),
        productionType:'',//作品类型  --从字典表提取；
        productionForm:1,//作品形式  --1为图片；2为视频；
        isChoiceness:1,
      },
      cList:[],
      //recommend 推荐
      rParam:{
        total:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 5,
        productionType:'',//作品类型  --从字典表提取；
        productionForm:1,//作品形式  --1为图片；2为视频；
        recommend:1
      },
      rList:[],
      //hot 热门
      hParam:{
        total:0,
        deleteFlag: 0,
        pageIndex: 1,
        pageSize: 5,
        productionType:'2',//作品类型  --从字典表提取；
        productionForm:2,//作品形式  --1为图片；2为视频；
      },
      hList:[],

      //meta优化
      parameTagIdF:0,
      isSearchEnd:false,

      isJB:false,
      isGS:false,
    }
  },
  computed: {
    ...mapState(["worksMeta"])
  },
  tdk() {
    let htmlStr = this.worksMeta.htmlStr
    return {
      title: this.headTitle,
      description: this.headDesc,
      keywords: this.headKeywords,
      ssrHeadAddInfo: `<link rel="canonical" href="http://www.renrendonghua.com">`,
      hideDiv: htmlStr
    };
  },
  serverPrefetch() {
    return this.fetchData();
  },
  mounted() {
    this.fetchData().then(
            setTimeout(()=>{
              this.initData()
            },500)

    );
  },
  methods: {
    fetchData(){
      //console.log("========fetchData====",this.$route.query.parameTagId)
      let pId = 0;
      if(this.$route.query.parameTagId){
        pId = this.$route.query.parameTagId
      }
      return this.$store
              .dispatch("FETCH_WORKS_META", {
                id: pId
              })
              .finally(() => {
                this.$loading(false);
                this.setSeo()
                updateTdk.call(this);
              });
    },
    initData() {
      let this_ = this
      let url=window.location.href.substring(window.location.href.indexOf("callback"),window.location.href.length).replace("callback=","");
      this_.$cookies.set("formUrl",url,60 * 60,"/","renrendonghua.com");
      // console.log("_this.$cookies1",url)
      // console.log("_this.$cookies2",this_.$cookies.get("formUrl"))
      this.isMounted = true;

      this_.isJB = false
      this_.isGS = false

      //传入作品类型Id
      let parameTagId = this_.$route.query.parameTagId
      let parameTagIdF= this_.$route.query.parameTagIdF //父级id

      let paramPageIndex = this_.$route.query.toPageNum

      if(!paramPageIndex){
        paramPageIndex = 1
      }



      this_.isLogin = this_.global.isLogin

      if(parameTagIdF){
        this_.parameTagIdF = parameTagId
        parameTagId = this_.$route.query.parameTagIdF
      }

      let parameTagName = this_.$route.query.parameTagName
      //传入作品标签
      let parameTagStr = this_.$route.query.parameTagStr

      this_.parameTagId = parameTagId
      this_.parameTagName = parameTagName
      this_.parameTagStr = parameTagStr

      window.ccH5PlayerJsLoaded = true;

      this_.tagParam.parentId  = -2
      tagApi.getList(this_.tagParam).then(reTag => {

        this_.contTabs=reTag.response

        if(reTag.response.length ==0){
          //console.log("TAGS IS NULL")
        }else{
          if(parameTagId && parameTagId !=0 ){
            tagApi.getOne(parameTagId).then(reTag => {
              //传入标签不可用，设置状态，使之不可关注
              this_.isStatus = reTag.response.status

              this_.parameTagName = reTag.response.tag
              parameTagName = reTag.response.tag

                this_.contTabs.forEach((item,index) => {
                  console.log('================',item.tag)
                if(item.id==parameTagId){
                  this_.isAtt = true
                  this_.contTabIndex = index

                  this_.productionParam.productionType = this.contTabs[index].id
                  this_.hotType = this.contTabs[index].tag
                  if(parameTagStr){
                    this_.productionParam.productionTags=parameTagStr
                  }


                  if(item.tag == '剧本'){
                    this_.isJB = true
                    tagApi.getList(this.historyParam).then(re =>{
                      this.historyList = re.response
                    })
                  }else if(item.tag == '故事'){
                    this_.isGS = true
                    tagApi.getList(this.historyParam).then(re =>{
                      this.historyList = re.response
                    })
                  }
                }

              })



              //console.log("parameTagId not null")
              //如果登录状态,判断是否已经关注
              if(this_.global.isLogin){

                if(this_.isAtt){

                  if(parameTagStr){
                    this_.productionParam.productionTags=parameTagStr
                  }else{
                    this.productionParam.productionTags=''
                  }
                  this.search(paramPageIndex)
                }
              }
              if(!this_.isAtt){
                //this.$message.error("未关注此类型")
                //return ;
                this_.contTabIndex = -1;
                this_.keywords = parameTagId
                this_.search2(parameTagId,parameTagName,parameTagStr,paramPageIndex);
              }else{
                this_.keywords = parameTagId
                this_.search2(parameTagId,parameTagName,parameTagStr,paramPageIndex);
              }

              //查询子类别
              this_.getProTypeChild()
            })
          }else{
            reTag.response.forEach(r =>{

              if(r.tag == '故事'){
                window.open("/storypart?plate=2&parameTagId="+r.id,'_self')
              }
              /*if(r.tag == '故事'){
                this_.productionParam.productionType = r.id
                this_.isAtt = true
                this_.hotType = r.tag

                this_.isGS = true
                tagApi.getList(this_.historyParam).then(re =>{
                  this_.historyList = re.response
                })
                //查询子类别
                this_.getProTypeChild()
                this_.keywords = this_.productionParam.productionType
                this_.search(paramPageIndex);
              }*/
            })

          }
        }
      })

    },
    setSeo() {
      let thiss = this
      thiss.headTitle = this.worksMeta.title
      thiss.headKeywords = this.worksMeta.keywords;
      thiss.headDesc =this.worksMeta.desc;
    },
    //转码没成功提示
    notStatus(statusCode){
      if(statusCode ==2){
        this.$message.error("视频转码失败...请等待管理员处理")
      }else{
        this.$message.error("视频转码中...请耐心等待")
      }
    },
    getProTypeChildThree(id){
      let thiss = this
      thiss.threeTypes =[]
      thiss.tagParam={}
      thiss.tagParam.parentId = id
      tagApi.getList(thiss.tagParam).then(reThreeTag => {
        reThreeTag.response.forEach(re =>{
          thiss.threeTypes.push(re)
        })
      })
    },
    getProTypeChild(){
      let thiss = this
      //console.log("getProTypeChild------------",thiss.productionParam.productionType)
      thiss.tagParam.parentId = thiss.productionParam.productionType

      tagApi.getList(thiss.tagParam).then(reTag => {
        thiss.childTypes = reTag.response

        thiss.threeTypes =[]

        thiss.childTypes.forEach( item =>{
          thiss.tagParam={}
          thiss.tagParam.parentId = item.id
          tagApi.getList(thiss.tagParam).then(reThreeTag => {
            /*let a = {'id':reThreeTag.response[0].parentId,'tag':'全部'}
            thiss.threeTypes.push(a);*/
            reThreeTag.response.forEach(re =>{
              thiss.threeTypes.push(re)
            })
          })
        })
      })
    },

    changePage(page){
      console.log(page)
      let urlNow=window.location.href

      if(urlNow.indexOf("toPageNum") > 0){
        urlNow = urlNow.substr(0,urlNow.indexOf("&toPageNum="))

        window.location.href= urlNow+"&toPageNum="+page
      }else {
        window.location.href= urlNow+"&toPageNum="+page
      }

    },
    search(page){
      let this_ = this
      //右侧分页初始化 第一页
      this.cParam.pageIndex = 1
      this.rParam.pageIndex = 1
      this.hParam.pageIndex = 1




      //查找系统标签下的自定义标签
      tagApi.getlistbyprotype(this_.productionParam.productionType).then(reTag2 => {

        if(this_.isAtt){
          //如果是关注类型,
          //查询类型下 标签
          this_.tagParam2 = reTag2.response

        }
        this_.productionParam.pageIndex = page
        //console.log("this_.productionParam.productionType=====page=======",page)
        productionApi.pageList(this_.productionParam).then(rePro => {

          this_.productionData = rePro.list

          this_.total = rePro.total
          this_.productionParam.pageIndex = rePro.pageNum

          //推荐
          // this_.getHotByType()
          //热门动画
          //this_.getHotMove();

          //新算法 推荐和精选 热门动画
          this_.getChoicenessList()
          this_.getRecommendList()
          this_.getHotList()

          // 移除组件
          this_.isReload = false
          // 在组件移除后，重新渲染组件
          // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
          this_.$nextTick(() => {
            this_.isReload = true
          })

          if(!this_.isSearchEnd && this_.parameTagIdF){
            setTimeout(()=>{
              this_.selectProTypeChild(this_.parameTagIdF,1)
            },50)

          }


          //console.log("isgs============",this_.isGS)
          //console.log("isJB============",this_.isJB)
          this_.isSearchEnd = true //查询结束
        })
      })
      this_.toTop()
    },
    // //热门
    // getHotByType(){
    //   let this_ = this
    //   this_.hotParam.productionType=this_.productionParam.productionType
    //   this_.hotParam.productionForm=1
    //   productionApi.getList(this_.hotParam).then(reHot => {
    //     this_.hotOne = reHot
    //   })
    // },
    // getHotMove(){
    //   let this_= this
    //   this_.hotParam.productionType=2
    //   this_.hotParam.productionForm=2
    //   productionApi.getList(this_.hotParam).then(reHot => {
    //     this_.hotTwo = reHot
    //   })
    // },

    //选择作品类型
    selectProType (item) {
      /* 修改为弹出新的路由
      this.contTabIndex = index
      this.productionParam.productionType = item.id
      this.hotType = item.tag
      this.productionParam.productionTags=''
      this.parameTagStr = ''
      this.isAtt = true
      this.getProTypeChild()
      this.search()
      */
      //console.log("=================================",item)
      window.open("/works?parameTagId="+item.id,'_self')

    },
    //作品子类型 查询--
    selectProTypeChild (id,type) {
      ///感觉没用 待删除 this.childTabIndex = index
      //console.log("选择作品子类型 ==============",id)
      this.productionParam.productionType = id
      this.productionParam.productionTags=''
      this.parameTagStr = ''
      this.isAtt = true
      if(type == 2){
        this.getProTypeChildThree(id)
      }
      if(type == 1){
        this.getProTypeChild()
      }

      this.search()
    },
    //选择作品子类型 -
    selectProTypeChildById (item) {
      //console.log("productionType=>",this.parameTagId)
      //console.log("item=>",item.id)
      window.open("/works?parameTagId="+item.id+"&parameTagIdF="+this.parameTagId,'_self')
    },


    //查询三级类型
    selectProTypeThreeChild (id) {
      ///感觉没用 待删除 this.childTabIndex = index
      //console.log("选择作品子类型 ==============",id)
      this.productionParam.productionType = id
      this.productionParam.productionTags=''
      this.parameTagStr = ''
      this.isAtt = true
      this.search()
    },

    selectProTypeHis(id){
      if(id == 0){
        this.productionParam.groupType = ''
      }else {
        this.productionParam.groupType = id
      }
      this.search()
    },
    //选择作品标签
    selectTab2 (tag) {
      this.productionParam.productionTags = tag
      this.search()
    },
    toTop () {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      })
    },
    selActivity(productionType,tagStr){
      //{path:'/works',query:{parameTagId:item.productionType,parameTagName:item.tagStr,parameTagStr:'活动'}

      // this.$router.push({
      //   path:'/works',
      //   query: {parameTagId:productionType,parameTagName:tagStr,parameTagStr:'活动',t:Math.random()}
      // })
      window.open("/works?parameTagId="+productionType+"&parameTagName="+tagStr+"&parameTagStr=活动",'_self')
    },

    //查询2 === 传入未关注作品ID,调用此查询
    search2(productionTypeId,productionTypeName, tag,paramPageIndex){
      //console.log("search2------")
      this.productionParam.productionType = productionTypeId
      this.hotType = productionTypeName
      this.productionParam.productionTags=''
      if(tag !=undefined && tag!=''){
        this.productionParam.productionTags=tag
      }
      this.search(paramPageIndex);
    },

    share () {
      this.dialogVisibleShare = true
    },
    jubao () {
      this.dialogVisibleJubao = true
    },
    shareWechat () {
      this.dialogVisibleShareWechat = true
      this.$nextTick(() => {
        new this.QRCode(this.$refs.qrcode, {
          width: 100,
          height: 100,
          text: 'http://www.baidu.com'
        })
      })
    },
    shareWeibo () {
      const url = 'http%3A%2F%2Fwww.wemeie.com%2F%23%2FcourseDetail%3FcourseId%3D2160'
      const title = '%E5%B0%8F%E7%8F%AD%E8%AF%BE'
      const pic = 'http%3A%2F%2Focs.21teacher.com%2Fdir-image%2F2019%2F12%2F31%2F69e73bac81a64b94b840ade2e2a2f37c.gif'
      const appkey = '#_loginLayer_1578022321857'
      const link = `http://service.weibo.com/share/share.php?url=${url}&title=${title}&pic=${pic}&appkey=${appkey}`
      window.open(link)
    },
    shareQQzone () {
      const url = 'http%3A%2F%2Fwww.wemeie.com%2F%23%2FcourseDetail%3FcourseId%3D2160'
      const title = '%E5%B0%8F%E7%8F%AD%E8%AF%BE'
      const desc = ''
      const summary = ''
      const site = '%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83'
      const link = `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${url}&title=${title}&desc=${desc}&summary=${summary}&site=${site}`
      window.open(link)
    },
    copyLink () {

    },
    shareMy(){
      let _this = this;
      if(_this.isLogin){
        apiService.doshare({"objectType": this.objType, "objectId": this.objId,"shareTo":1,"time": new Date().getMilliseconds()}).then(data => {
          this.$message.success("成功分享到我的动态!");
          this.dialogVisibleShare = false;
        })
      }else{
        // _this.$message({
        //   message: '您尚未登录,请登录后操作',
        //   type: 'error'
        // });
        _this.toLog();
      }
    },
    toLog(){
      this.$router.push({
        path:'/login?callback=' + window.location.href,
      })

    } ,

    //右侧列表方法
    //精选
    getChoicenessList() {
      this.cParam.productionType=this.productionParam.productionType
      productionApi.getProductionPageRightList(this.cParam).then(data => {
        this.cList=data.response.list;
        this.cParam.total = data.response.total
        if(this.cParam.pageIndex == Math.ceil(this.cParam.total/this.cParam.pageSize)){
          this.cParam.pageIndex =1
        }else{
          this.cParam.pageIndex = this.cParam.pageIndex +1
        }


      })
    },

    //推荐
    getRecommendList() {
      this.rParam.productionType=this.productionParam.productionType
      productionApi.getProductionPageRightList(this.rParam).then(data => {
        this.rList=data.response.list;

        this.rParam.total = data.response.total
        if(this.rParam.pageIndex == Math.ceil(this.rParam.total/this.rParam.pageSize)){
          this.rParam.pageIndex =1
        }else{
          this.rParam.pageIndex = this.rParam.pageIndex +1
        }
      })
    },
    getHotList(){
      //this.hParam.productionType=2
      productionApi.getProductionPageHotList(this.hParam).then(data => {
        this.hList=data.response.list;

        this.hParam.total = data.response.total
        if(this.hParam.pageIndex == Math.ceil(this.hParam.total/this.hParam.pageSize)){
          this.hParam.pageIndex =1
        }else{
          this.hParam.pageIndex = this.hParam.pageIndex +1
        }
      })
    },
    addUserTag(){
      var _this = this;
      if(_this.global.isLogin) {
        apiService.addUserInterest({"tagId": _this.parameTagId,"time": new Date().getMilliseconds()}).then(data => {
          if (data.code == 1) {
            _this.isAtt = true
            window.location.reload()
          }
        })
      }else{
        // _this.$message({
        //   message: '您尚未登录,请登录后操作',
        //   type: 'error'
        // });
        _this.toLog();
      }
    },

    // setHead(){
    //   let thiss = this
    //   let tabs = this.contTabs
    //   let type = "";
    //
    //   if(thiss.parameTagName!=null){
    //     type = thiss.parameTagName
    //   }else{
    //     tabs.forEach((item, index)  => {
    //       if(item.id == thiss.productionParam.productionType){
    //         type = item.tag
    //       }
    //     })
    //   }
    //
    //   document.title = type+"作品——作品——人人动画网【官网】"
    //   let head = document.getElementsByTagName('head');
    //   let meta = document.createElement('meta');
    //
    //   if(type=="C4D作品"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "C4D,渲染图,C4D渲染图")
    //     thiss.headDesc ="平生无其他所好，只爱C4D！欢迎加入C4D爱好者圣地")
    //   }else if(type=="分镜"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "分镜,故事版,故事板")
    //     thiss.headDesc ="导演如何画分镜？分镜有哪些类别？如何提高分镜能力？")
    //   }else if(type=="概念设计"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "概念设计,构图,用光,配色")
    //     thiss.headDesc ="大家都在这里讨论，如何在概念设计中合理构图，配色，用光，刻画细节!")
    //   }else if(type=="插画"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "插画 ,手绘,电脑绘画,游戏原画")
    //     thiss.headDesc ="如果您喜欢插画，喜欢手绘，喜欢手绘，喜欢电脑绘画，请加入插画爱好者交流平台!，这里有中国最优秀的插画爱好者")
    //   }else if(type=="动图"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "动图 ,previz作品,分镜演示")
    //     thiss.headDesc ="网罗当下最热门动态图片、动态图、gif图片素材、高清动图图片")
    //   }else if(type=="场景"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "动图 ,previz作品,分镜演示")
    //     thiss.headDesc ="像宫崎骏的作品一样，每一个场景都会惊艳到你。")
    //   }else if(type=="角色"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "角色 ,人物角色,动物角色")
    //     thiss.headDesc ="我们偏执于追求最精致的角色造型设计，包扣：人物，动物，女人，男人，孩子，老人，人体器官，异形怪物，机器人，机甲。")
    //   }else if(type=="素描"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "角色 ,人物角色,动物角色")
    //     thiss.headDesc ="最美好的日子，就是和有趣的灵魂一起学习素描、练习素描！不管您是想玩素描人物，素描静物，还是素描头像，我们都欢迎您。")
    //   }else if(type=="剪辑"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "剪辑 ,影视剪辑,动漫剪辑,视频混剪")
    //     thiss.headDesc ="无论是影视还是动漫，剪辑艺术都将决定一部作品是否能打动用户，是否能打动资本市场。您是否就是这样的剪辑师？")
    //   }else if(type=="动画"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "mg动画 ,三维动画,二维动画,快速动画")
    //     thiss.headDesc ="优秀的动画作品应该被更多的人记住，优秀的动画人应该能收获更多的掌声和认可。人人动画，为动画人发声，助力每个人实现自己的动画梦。")
    //   }else if(type=="游戏"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "游戏动画 ,游戏剪辑,二维动画,快速动画")
    //     thiss.headDesc ="不负年华不负卿！选择人人动画网，就是选择为自己代言！")
    //   }else if(type=="广告"){
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "广告 ,动画广告,平面广告,海报,影视广告")
    //     thiss.headDesc ="揭晓那些不为人知的广告创意，捕捉那些一闪而过的思维灵感，欢迎参观我的广告创意实验室。")
    //   }else {
    //     document.title = "作品——人人动画网【官网】"
    //     document.querySelector('meta[name="keywords"]').setAttribute('content', "动画,C4D,剪辑")
    //     thiss.headDesc ="如果你有激动人心的创意，如果你有惊鸿一瞥的美术设计，如果你有制作模型、渲染、特效的神功绝技，请加入我们！人人动画网将会成为你充分展现才能的宏大舞台！")
    //   }
    //
    // },
  }
}
</script>

<style scoped lang="less">
.page-works {
  padding-top: @NAVHEIGHT;
  .common-type-list {
    padding-top: 20px;
  }
}
.pagintion-f {
  padding: 20px 0 40px;
  text-align: center;
}
.paeparation{
  .types-list{
    padding-bottom: 0;
  }
}
@media screen and (max-width: 750px) {
  .page-works {
    .common-type-list {
      padding-top: 5px;
      margin-bottom: 5px;
    }
  }
}
// @import "../project/pro.less";
// .projn-item{
//   .itemn-info{
//     .type.bjz{
//       color: #0082fe !important;
//       background: #ebf5ff;
//       border: none !important;
//     }
//   }
// }
// .btn-has-user{
//   align-items: center;
//   .user-info{
//     display: flex;
//     align-items: center;
//     font-size: 14px;
//     font-weight: bold;
//     .avat{
//       margin-right: 5px;
//       width: 30px;
//       height: 30px;
//       background-size: cover;
//       border-radius: 50%;
//     }
//   }
// }
//@import "../../assets/less/stylePublic.less";
</style>
